<div class="app-shell">
  <nav class="topbar">
    <div class="brand">
      <div class="logo-mark">
        <img src="/itrace-logo.jpeg" alt="iTrace" />
      </div>
      <span class="brand-name">iTrace</span>
    </div>

    @if (session) {
      <div class="user-chip">
        <div class="avatar">{{ session.fullName.charAt(0) }}</div>
        <div class="user-chip__info">
          <span class="name">{{ session.fullName }}</span>
          <span class="role">{{ session.role }}</span>
        </div>
        <button class="logout-btn" (click)="logout()" aria-label="Log out">
          <span class="material-icons">logout</span>
        </button>
      </div>
    }
  </nav>

  <div class="shell-body">
    <aside class="sidenav">
      <div class="sidenav__nav">
        <a
          routerLink="/"
          routerLinkActive="sidenav__item--active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="sidenav__item"
        >
          <span class="material-icons">dashboard</span>
          <span class="sidenav__item-label">Dashboard</span>
        </a>

        @if (canViewProjects) {
          <a routerLink="/projects" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">inventory_2</span>
            <span class="sidenav__item-label">Projects</span>
          </a>
        }

        @if (canManageProjects) {
          <a routerLink="/export-requests" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">swap_horiz</span>
            <span class="sidenav__item-label">Export requests</span>
            @if (pendingExportRequests() > 0) {
              <span class="badge">{{ pendingExportRequests() }}</span>
            }
          </a>
        }

        @if (canViewOwnWallet) {
          <a routerLink="/wallet" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">account_balance_wallet</span>
            <span class="sidenav__item-label">Wallet</span>
          </a>
        }

        @if (canManageApiKeys) {
          <a routerLink="/api-keys" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">vpn_key</span>
            <span class="sidenav__item-label">API keys</span>
          </a>
        }

        @if (canManageCompanyUsers) {
          <a routerLink="/company-users" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">group</span>
            <span class="sidenav__item-label">Company users</span>
          </a>
        }

        @if (canViewOwnCompany) {
          <a routerLink="/company" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">apartment</span>
            <span class="sidenav__item-label">My company</span>
          </a>
        }

        @if (canViewCountrySchema) {
          <a routerLink="/country-schema" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">account_tree</span>
            <span class="sidenav__item-label">Field mapping</span>
          </a>

          <a routerLink="/country-xml-templates" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">code</span>
            <span class="sidenav__item-label">XML templates</span>
          </a>

          <a routerLink="/country-compare" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">compare_arrows</span>
            <span class="sidenav__item-label">Compare countries</span>
          </a>

          <a routerLink="/xml-tester" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">code</span>
            <span class="sidenav__item-label">XML tester</span>
          </a>
        }

        @if (
          canReviewCompanies ||
          canManagePlatformUsers ||
          canViewPlatformWallet ||
          canViewPlatformConfig ||
          canViewPlatformExportRequests
        ) {
          <div class="sidenav__section">Platform</div>
        }

        @if (canViewPlatformExportRequests) {
          <a routerLink="/admin/export-requests" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">swap_horiz</span>
            <span class="sidenav__item-label">Export requests</span>
          </a>
        }

        @if (canReviewCompanies) {
          <a
            routerLink="/admin/companies"
            routerLinkActive="sidenav__item--active"
            class="sidenav__item"
            (click)="$event.preventDefault(); openCompanyApprovals()"
          >
            <span class="material-icons">fact_check</span>
            <span class="sidenav__item-label">Company approvals</span>
            @if (pendingCompanies() > 0) {
              <span class="badge">{{ pendingCompanies() }}</span>
            }
          </a>
        }

        @if (canManagePlatformUsers) {
          <a routerLink="/admin/users" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">manage_accounts</span>
            <span class="sidenav__item-label">Platform users</span>
          </a>
        }

        @if (canViewPlatformWallet) {
          <a routerLink="/admin/wallet" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">account_balance</span>
            <span class="sidenav__item-label">Platform wallet</span>
          </a>
        }

        @if (canViewPlatformConfig) {
          <a routerLink="/admin/country-mappings" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">public</span>
            <span class="sidenav__item-label">Country mappings</span>
          </a>

          <a routerLink="/admin/field-rules" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">rule</span>
            <span class="sidenav__item-label">Term rules</span>
          </a>

          <a routerLink="/admin/general-terms" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">list_alt</span>
            <span class="sidenav__item-label">General terms</span>
          </a>

          <a routerLink="/admin/term-mapping-matrix" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">grid_on</span>
            <span class="sidenav__item-label">Term mapping matrix</span>
          </a>

          <a routerLink="/admin/audit-events" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">history</span>
            <span class="sidenav__item-label">Audit events</span>
          </a>
        }

        @if (canViewPlatformDiagnostics) {
          <a routerLink="/admin/zetrix-status" routerLinkActive="sidenav__item--active" class="sidenav__item">
            <span class="material-icons">monitor_heart</span>
            <span class="sidenav__item-label">Zetrix status</span>
          </a>
        }
      </div>

      @if (session) {
        <div class="sidenav__footer">
          <span class="sidenav__footer-label">Signed in as</span>
          <span class="sidenav__footer-value">{{ session.email }}</span>
          @if (session.companyId) {
            <span class="sidenav__footer-value sidenav__footer-value--muted">{{ session.companyId }}</span>
          }
        </div>
      }
    </aside>

    <main class="shell-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
